import { useT } from "@transifex/react";
import BasePopupWrapper, { TitleColorVariants } from "../../basic/popups/BasePopupWrapper";
import { ClassActivityCategory } from "../../constants/ClassActivityConstants";
import { ButtonColorVariant } from "../teacherArea/AreaButton";

interface InviteClassMembersPopupProps {
    isOpen: boolean;
    schoolClassName: string;
    onLater: () => void;
    onInviteNow: () => void;
    category: ClassActivityCategory;
}

interface CategoryStyle {
    titleColor: TitleColorVariants;
    buttonColor: ButtonColorVariant;
}

const categoryStyles: Record<ClassActivityCategory, CategoryStyle> = {
    [ClassActivityCategory.TEST]: {
        titleColor: TitleColorVariants.DEFAULT,
        buttonColor: ButtonColorVariant.DEFAULT,
    },
    [ClassActivityCategory.VOCAB_TRAINING]: {
        titleColor: TitleColorVariants.SECONDARY,
        buttonColor: ButtonColorVariant.SECONDARY,
    },
};

const InviteClassMembersPopup = (props: InviteClassMembersPopupProps) => {
    const t = useT();

    const t_inviteTitle = t("Invite students", {
        _tags: "ShareFlow, InviteClassMembersPopup",
    });
    const t_inviteBody1 = t('Your class "{className}" has no students yet. Would you like to invite students now?', {
        className: props.schoolClassName,
        _tags: "ShareFlow, InviteClassMembersPopup",
    });
    const t_inviteBody2 = t("You can add students anytime later.", {
        _tags: "ShareFlow, InviteClassMembersPopup",
    });
    const t_later = t("Later", { _tags: "ShareFlow, InviteClassMembersPopup" });
    const t_inviteNow = t("Invite now", { _tags: "ShareFlow, InviteClassMembersPopup" });

    const styles = categoryStyles[props.category];

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={props.onLater}
            title={t_inviteTitle}
            titleColor={styles.titleColor}
            secondaryButton={{
                text: t_later,
                onClick: props.onLater,
                colorVariant: styles.buttonColor,
                className: "min-w-[180px]",
            }}
            primaryButton={{
                text: t_inviteNow,
                onClick: props.onInviteNow,
                colorVariant: styles.buttonColor,
                className: "min-w-[180px]",
            }}
        >
            <div className="flex flex-col gap-xs">
                <p className="text-l text-p6-grey-dark">{t_inviteBody1}</p>
                <p className="text-l text-p6-grey-dark">{t_inviteBody2}</p>
            </div>
        </BasePopupWrapper>
    );
};

export default InviteClassMembersPopup;
